import { useMemo } from 'react';

import { useFormik } from 'formik';
import * as Yup from 'yup';

function parseCurrency(currencyStr) {
  // Remove any characters that are not digits, a decimal point, or a minus sign.
  const cleanedStr = currencyStr.replace(/[^0-9.-]+/g, '');

  const number = parseFloat(cleanedStr);

  return isNaN(number) ? '' : number;
}

function parseValuesBeforeSubmit(values, fields) {
  const parsedValues = { ...values };

  Object.keys(parsedValues).forEach((key) => {
    const field = fields.find((field) => field.name === key);

    if (field) {
      switch (field.type) {
        case 'currency':
          parsedValues[key] = parseCurrency(parsedValues[key]);
          break;
        default:
          break;
      }
    }
  });

  return parsedValues;
}

function createFormikInitialData(fields, serverData) {
  return fields.flat().reduce((acc, field) => {
    if (field.type === 'custom') {
      return acc;
    }

    let initialValue = '';
    if (field.initialValue) {
      initialValue = field.initialValue;
    }

    if (serverData) {
      initialValue = Array.isArray(serverData[field.name])
        ? serverData[field.name].join(', ')
        : serverData[field.name];

      if (field.type === 'date') {
        initialValue = serverData[field.name]
          ? new Date(serverData[field.name])
          : '';
      }

      if (initialValue === null) {
        initialValue = '';
      }
    }

    acc[field.name] = initialValue;
    return acc;
  }, {});
}

export default function useForm({
  createHandler,
  updateHandler,
  serverData,
  fields,
  onSubmitFinish,
}) {
  const validationObject = useMemo(
    () =>
      fields.flat().reduce((acc, field) => {
        /*  if (field.type === 'custom') {
          return acc;
        } */

        acc[field.name] = field.validation;
        return acc;
      }, {}),
    [fields]
  );

  let validationSchema = useMemo(
    () => Yup.object().shape(validationObject),
    [validationObject]
  );

  const formik = useFormik({
    initialValues: createFormikInitialData(fields, serverData),
    validationSchema,
    onSubmit: async (values) => {
      try {
        if (serverData) {
          const data = { ...values };

          if (serverData.id) {
            data.id = serverData.id;
          }

          await updateHandler(parseValuesBeforeSubmit(data, fields));
        } else {
          await createHandler(parseValuesBeforeSubmit(values, fields));
        }

        onSubmitFinish?.(values);
      } catch (error) {
        console.log(error);
      }
    },
    enableReinitialize: true,
  });

  return formik;
}
